<template>
  <header class="sf-page-header">
    <div v-bind:class="[ 'sf-container', narrow ? 'sf-container--narrow' : null ]">
      <div class="sf-page-header__inner">
        <div class="sf-page-header__main">
          <div class="sf-page-header__eyebrow"
               v-if="!!this.$slots['left-button']">
            <slot name="left-button" />
          </div>
          <slot>
            <h1 class="sf-page-header__title">{{ title }}</h1>
          </slot>
          <p class="sf-page-header__subtitle"
             v-if="subtitle != null && subtitle.length > 0">{{ subtitle }}</p>
        </div>
        <div class="sf-page-header__actions"
             v-if="!!this.$slots['right-button'] || !!this.$slots['menu']">
          <slot name="right-button" />
          <slot name="menu" />
        </div>
      </div>
      <div class="sf-page-header__tabs"
           v-if="!!this.$slots['tabs']">
        <slot name="tabs" />
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'TopHeader',
    props: {
      narrow: Boolean,
      subtitle: String,
      title: String
    }
  }
</script>
